import React, { Suspense, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import RouteFallback from "../components/shared/RouteFallback";

const MagicRoot = () => {
    const loginToken = useSelector((state) => state.reducer.userToken);
    const userLoggedIn = useSelector((state) => state.reducer.userLoggedIn);
    const navigate = useNavigate();
    const isShipper = window.location.pathname.includes("shipper");
    const isAgent = window.location.pathname.includes("agent");

    useEffect(() => {
        if (!loginToken || userLoggedIn?.role !== (isShipper ? "shipper" : isAgent ? "agent" : "user")) {
            navigate("/", { replace: true });
        }
    }, [loginToken, navigate, userLoggedIn?.role, isShipper, isAgent]);

    if (!loginToken) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-fk-canvas dark:bg-[#0A0F1A]">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 dark:border-gray-100 mx-auto"></div>
                    <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">Redirecting...</p>
                </div>
            </div>
        );
    }

    return (
        <Suspense fallback={<RouteFallback />}>
            <Outlet />
        </Suspense>
    );
};

export default MagicRoot;

